export default __webpack_public_path__ + "static/media/logoM04.89e81c75.png";